// Polyfill promises for IE 11 support (import before everything else!)
import 'ts-polyfill';

import '@nackle/translation-editor/src/index.tsx';
import React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './app.less';
import App from './components/app';
import createAppStore from './store';
import { BridgeWrapper } from './BridgeWrapper';

const store = createAppStore();

const everything = (
    <Provider store={store}>
        <BridgeWrapper>
            <App />
        </BridgeWrapper>
    </Provider>
);

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(everything, document.getElementById('app'));
